<template>
  <q-badge
    class="q-ml-xs"
    rounded
    :color="colorMap[computedConnectionState] || 'neutral-50'"
    :style="{ width: '12px', height: '12px' }"
    :title="`Chat ${computedConnectionState}`"
  />
</template>

<script setup>
const colorMap = {
  connected: "success-70",
  connecting: "neutral-50",
  disconnected: "negative",
};

const { connectionState, conversationsState } = storeToRefs(useChatStore());

const computedConnectionState = computed(() => {
  if (conversationsState.value === "failed") {
    return "disconnected";
  } else {
    return connectionState.value;
  }
});
</script>
